import styles from "./SimpleApiIntegration.module.css";
import { FaCheckCircle } from "react-icons/fa";


const features = [
    "Sub-100ms time-to-first-byte latency",
    "15+ emotional tones per voice",
    "12+ languages with native accents",
    "Real-time WebSocket streaming",
    "REST API for batch processing",
    "SSML support for fine control",
    "Custom pronunciation dictionaries",
    "Speed & pitch adjustment",
    "On-premise deployment available",
];


const SimpleApiIntegration = () => {
    return (
        <section className={styles.wrapper}>
            <div className={styles.container}>
                {/* Left Content */}
                <div className={styles.left}>
                    <h2>Simple API Integration</h2>
                    <p className={styles.subtitle}>
                        Get started with just a few lines of code. Our RESTful API is designed
                        for developers who want powerful features without complexity.
                    </p>


                    <ul className={styles.list}>
                        {features.map((item, index) => (
                            <li key={index}>
                                <FaCheckCircle />
                                {item}
                            </li>
                        ))}
                    </ul>


                    <button className={styles.button}>View Full Documentation</button>
                </div>


                {/* Right Code Block */}
                <div className={styles.codeCard}>
                    <div className={styles.codeHeader}>
                        <span className={styles.dotRed}></span>
                        <span className={styles.dotYellow}></span>
                        <span className={styles.dotGreen}></span>
                        <span className={styles.title}>API Request</span>
                    </div>


                    <pre className={styles.codeBlock}>
                        {`POST /api/v1/synthesize


curl -X POST https://api.toxbox.com/v1/synthesize \\
-H "Authorization: Bearer YOUR_API_KEY" \\
-H "Content-Type: application/json" \\
-d '{
"text": "आपका order ship हो गया है",
"voice_id": "meera-natural",
"emotion": "happy",
"speed": 1.0,
"sample_rate": 24000
}'`}
                    </pre>
                </div>
            </div>
        </section>
    );
};


export default SimpleApiIntegration;